$(function () {
  'use strict'

  /* ==============================================================  /
   *               Filter sidebar of showgoer list
   * ============================================================== */
  $('.filter-icon .mdi').click(function () {
    $('.inbox-panel.inbox-collapse-left').toggleClass('show')
  })

})



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/scripts/yumiwi/showgoers.js